import React from 'react';

import Layout from '../components/Layout';
import PartialsHeader from '../components/Partials/PartialsHeader';
import Privacy from '../components/Policy/Privacy';

export default () => {
  return (
    <Layout
      title="Privacy policy - Ulam Labs"
      description="Our services and products are built on a foundation of security and GDPR requirements to secure and be transparent for our clients."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title policy-title">ULAM LABS Privacy Policy</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <Privacy />
    </Layout>
  );
};
